<template>
  <b-button
    v-if="hasBack"
    size="sm"
    pill
    variant="outline-primary"
    class="mb-4"
    @click="hasHistory() ? $router.go(-1) : $router.push('/')"
  >
    <span class="small mr-1"><b-icon icon="chevron-left"></b-icon></span>
    <span class="pr-1">Back</span>
  </b-button>
</template>

<script>
export default {
  name: 'App',
  computed: {
    hasBack() {
      if (this.$route.name == 'Search') return false
      return true
    },
  },
  methods: {
    hasHistory() {
      return window.history.length > 2
    },
  },
}
</script>
